export default __webpack_public_path__ + "static/Poppins-Medium.673ed423.ttf";